module.exports = __webpack_public_path__ + "img/close.fdd5b242.svg";